import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch, shallowEqual, } from "react-redux";
import { InfoWindowF, MarkerF, useGoogleMap } from '@react-google-maps/api';

import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
// import carecenterIcon from '../../assets/carecentericon.svg';
// import housingIcon from '../../assets/house.svg';
// import coeIcon from '../../assets/coe.svg';

import { activateMarker } from "../../features/activeMarkers";// activateCareCenter, activateWarrior /*} from '../features/activeMarkers'
import { setPublicPinClicked/*, getProfileFromID, getAIProfileSummary */ } from "../../features/dataProcessingSlice"
import { PinChip } from '../MessageProfile';
import { AppDispatch } from "../../app/store";
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';
import { useGetProfileQuery, useGetProfilesPinDataForDefaultPointQuery/*, useGetProfilesPinDataQuery*/ } from "../../features/profilesSlice";
import { CircularProgressCentered } from "../../app/components/sharedcomponents";
import { Alert, Skeleton } from "@mui/material";

import { ShowMarkerType } from "./InstitutionMarkers";
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import { NavigateOptions, To, useNavigate } from "react-router-dom";
import { chatApi, useSetChatUserMutation, DirectChatUsers } from "../../features/ChatSlice";
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { useAuthProfile } from "../../app/hooks";
//import { IsProdChatUserInTest, prodChatUserInTestMessage } from "../messaging/ChatMain";
import { showDirectChat } from "../../features/dialogSlice";
import { Condition, baseName, coonditionContext } from "../..";
//const MMWarriorSVG2 = require(`../../assets/patienticon${baseName??''}.png`);

import { loadImage, loadImageSync } from "../../app/utils";
//import MMWarriorPNG from '../../assets/patienticon.png';
import CaregiverPNG from '../../assets/caregiver.png';
import MedicPNG from '../../assets/medic.png';
import OtherPNG from '../../assets/other.png';
import { useAgentData } from "../map/MapCircle";
import { skipToken } from "@reduxjs/toolkit/query";
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CloseIcon from '@mui/icons-material/Close';

import { setActivePinModal, setBottomSheetState } from '../../features/utilitySlice';
import { useIsMobile } from '../../app/IsMobileContext';

export const GetUserTypePinPNG = (name: string) => {
  switch (name) {
    case "P":
      //return MMWarriorPNG
      return loadImageSync(`patienticon${baseName}.png`)
    case "C":
      return CaregiverPNG
    case "M":
      return MedicPNG
    case "O":
      return OtherPNG
    default:
      return null
  }
}

const iconCache = new Map<string, { url: string, scaledSize: google.maps.Size }>();
// Smooth continuous scaling: small when zoomed out, full size when zoomed in
export const getMarkerSize = (zoom: number): number => {
  const minSize = 20
  const maxSize = 58
  const minZoom = 3
  const maxZoom = 12
  if (zoom >= maxZoom) return maxSize
  if (zoom <= minZoom) return minSize
  return Math.round(minSize + (maxSize - minSize) * (zoom - minZoom) / (maxZoom - minZoom))
}
export const customIcon: (url: string, size: number) => { url: string, scaledSize?: google.maps.Size } = (url, size) => {
  const cacheKey = `${url}_${size}`
  const cached = iconCache.get(cacheKey)
  if (cached) return cached
  const icon = {
    url: url,//userTypePinSVG as unknown as string,
    scaledSize: new window.google.maps.Size(size, size),
  }
  iconCache.set(cacheKey, icon)
  return icon
};

// Easing with overshoot — gives a balloon-inflate feel
function easeOutBack(t: number): number {
  const c1 = 1.70158
  const c3 = c1 + 1
  return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2)
}

/**
 * Animate a Google Maps marker icon growing from its current size to a
 * larger size (balloon inflate). Returns a promise that resolves with
 * the final inflated size once the animation is done.
 */
export function inflateMarker(
  marker: any,
  iconUrl: string,
  startSize: number,
  /** How many times larger the pin should grow (e.g. 2.5 = 2.5× original) */
  scaleFactor: number = 2.5,
  duration: number = 280,
): Promise<number> {
  const endSize = Math.round(startSize * scaleFactor)
  return new Promise(resolve => {
    const t0 = performance.now()
    function step(now: number) {
      const t = Math.min((now - t0) / duration, 1)
      const size = Math.round(startSize + (endSize - startSize) * easeOutBack(t))
      marker.setIcon({ url: iconUrl, scaledSize: new window.google.maps.Size(size, size) })
      if (t < 1) requestAnimationFrame(step)
      else resolve(endSize)
    }
    requestAnimationFrame(step)
  })
}

const HOLD_THRESHOLD_MS = 180

/**
 * Helper: extract screen coordinates from a Google Maps marker event.
 */
export function screenCoordsFromEvent(event: any): { sx: number; sy: number } | null {
  const domEvt = event?.domEvent
  const touch = domEvt?.changedTouches?.[0]
  const sx = touch ? touch.clientX : domEvt?.clientX
  const sy = touch ? touch.clientY : domEvt?.clientY
  return (sx != null && sy != null) ? { sx, sy } : null
}

/**
 * Set up tap + hold behaviour on a Google Maps marker (mobile only).
 *
 * - Tap  → dispatches the modal normally (permanent open).
 * - Hold → after threshold dispatches a *preview* modal; releasing closes it.
 */
export function setupMarkerTapAndHold(
  marker: any,
  opts: {
    isMobileRef: React.MutableRefObject<boolean>,
    dispatch: Function,
    buildPayload: (coords: { sx: number; sy: number }) => { data: any; category: string; heroInfo?: any },
    onDesktopClick: (event: any) => void,
    setInfoWindowOpen: (v: boolean) => void,
    activateId: any,
  }
) {
  let holdTimer: ReturnType<typeof setTimeout> | null = null
  let wasHold = false
  let coords: { sx: number; sy: number } | null = null
  let releaseCleanup: (() => void) | null = null
  // If the finger moves more than this many pixels, it's a pan — cancel the hold
  const MOVE_THRESHOLD = 10

  window.google.maps.event.addListener(marker, "mousedown", function (event: any) {
    if (!opts.isMobileRef.current) return
    wasHold = false
    coords = screenCoordsFromEvent(event)
    const startX = coords?.sx ?? 0
    const startY = coords?.sy ?? 0

    holdTimer = setTimeout(() => {
      wasHold = true
      opts.dispatch(activateMarker({ id: opts.activateId, disableHover: true }))
      opts.setInfoWindowOpen(false)
      if (coords) {
        const payload = opts.buildPayload(coords)
        opts.dispatch(setActivePinModal({ ...payload, preview: true } as any))
      }
    }, HOLD_THRESHOLD_MS)

    // Cancel hold if finger moves (user is panning)
    function onMove(e: TouchEvent | MouseEvent) {
      const t = 'touches' in e ? e.touches[0] : e
      const dx = t.clientX - startX
      const dy = t.clientY - startY
      if (dx * dx + dy * dy > MOVE_THRESHOLD * MOVE_THRESHOLD) {
        if (holdTimer) { clearTimeout(holdTimer); holdTimer = null }
        // If preview already opened, close it
        if (wasHold) {
          opts.dispatch(setActivePinModal(null))
          opts.dispatch(activateMarker({ id: null, disableHover: false }))
          wasHold = false
        }
        cleanupAll()
      }
    }

    // Use capture phase on window to catch the event before Maps can swallow it
    function onRelease() {
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null }
      if (wasHold) {
        opts.dispatch(setActivePinModal(null))
        opts.dispatch(activateMarker({ id: null, disableHover: false }))
        // Keep wasHold true so the subsequent click event gets suppressed
        setTimeout(() => { wasHold = false }, 50)
      }
      cleanupAll()
    }
    function cleanupAll() {
      window.removeEventListener('touchend', onRelease, true)
      window.removeEventListener('touchcancel', onRelease, true)
      window.removeEventListener('mouseup', onRelease, true)
      window.removeEventListener('touchmove', onMove as EventListener, true)
      window.removeEventListener('mousemove', onMove as EventListener, true)
      releaseCleanup = null
    }
    // Clean up any prior listener (shouldn't happen, but safety)
    if (releaseCleanup) releaseCleanup()
    window.addEventListener('touchend', onRelease, { capture: true, once: true })
    window.addEventListener('touchcancel', onRelease, { capture: true, once: true })
    window.addEventListener('mouseup', onRelease, { capture: true, once: true })
    window.addEventListener('touchmove', onMove as EventListener, { capture: true })
    window.addEventListener('mousemove', onMove as EventListener, { capture: true })
    releaseCleanup = cleanupAll
  })

  window.google.maps.event.addListener(marker, "click", function (event: any) {
    if (opts.isMobileRef.current) {
      if (wasHold) { wasHold = false; return } // was a hold, ignore the click
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null }
      const c = screenCoordsFromEvent(event)
      opts.dispatch(activateMarker({ id: opts.activateId, disableHover: true }))
      opts.setInfoWindowOpen(false)
      if (c) {
        const payload = opts.buildPayload(c)
        opts.dispatch(setActivePinModal(payload as any))
      } else {
        opts.dispatch(setActivePinModal(opts.buildPayload({ sx: 0, sy: 0 }) as any))
      }
      return
    }
    opts.onDesktopClick(event)
  })
}

// Hook: listens to native Google Maps zoom_changed event and imperatively
// updates the marker icon. Completely bypasses React rendering.
export function useZoomIconSync(
  markerRef: React.MutableRefObject<any>,
  iconUrl: string | null
) {
  const map = useGoogleMap()
  const sizeRef = useRef(getMarkerSize(map?.getZoom() ?? 10))

  useEffect(() => {
    if (!map) return
    const handleZoom = () => {
      const zoom = map.getZoom()
      if (zoom != null && iconUrl) {
        const newSize = getMarkerSize(zoom)
        if (newSize !== sizeRef.current) {
          sizeRef.current = newSize
          if (markerRef.current) {
            markerRef.current.setIcon(customIcon(iconUrl, newSize))
          }
        }
      }
    }
    handleZoom()
    const listener = map.addListener('zoom_changed', handleZoom)
    return () => listener.remove()
  }, [map, iconUrl])

  return sizeRef
}

export const MMMarkerNotMemoized: React.FC<{ data: any }> = ({ data }) => {
  const { baseName } = React.useContext<Condition>(coonditionContext);

  const markerRef = useRef<any>(null);
  const dispatch = useDispatch<AppDispatch>()
  const isMobile = useIsMobile()
  const isMobileRef = useRef(isMobile)
  useEffect(() => { isMobileRef.current = isMobile }, [isMobile])

  const [infoWindowOpen, setInfoWindowOpen] = useState(false);

  const isMarkerActive = useSelector(
    (state: any) => {
      if (state.activeMarkers?.id === data.id) {
        return true
      }
      return false
    }
  );

  const markerType = data.type

  const userTypePinPNG = GetUserTypePinPNG(markerType)
  // Imperatively sync icon size with zoom via native Google Maps event — no React re-renders
  const sizeRef = useZoomIconSync(markerRef, userTypePinPNG as string | null)

  function onLoad(marker: any) {
    markerRef.current = marker
    setupMarkerTapAndHold(marker, {
      isMobileRef,
      dispatch,
      activateId: data.id,
      setInfoWindowOpen,
      buildPayload: (c) => ({
        data, category: 'user',
        heroInfo: userTypePinPNG
          ? { screenX: c.sx, screenY: c.sy, iconUrl: userTypePinPNG as string, iconSize: sizeRef.current }
          : undefined,
      }),
      onDesktopClick: () => {
        if (markerType === "P" || markerType === "C" || markerType === "M" || markerType === "O") {
          dispatch(setPublicPinClicked(data.id))
        } else {
          dispatch(setPublicPinClicked(false))
        }
        dispatch(activateMarker({ id: data.id, disableHover: true }))
        setInfoWindowOpen(false)
      },
    })
  }

  function handleMouseOver() {
    if (isMarkerActive) {//if (activeMarkers.disableHover) {
      return;
    }
    setInfoWindowOpen(true);
    //activateCallBack(id)
  };

  function handleMouseOut() {
    if (isMarkerActive) {//if (activeMarkers.disableHover) {
      return;
    }
    setInfoWindowOpen(false);
  };


  function handleWindowClose() {
    setInfoWindowOpen(false);
    dispatch(activateMarker({ id: null, disableHover: false }))
    dispatch(setPublicPinClicked(false))
  };


  //let test =  loadImageSync(`coe.png`)
  if (userTypePinPNG)
    return (
      <MarkerF
        key={`marker-${data.id}`}
        onLoad={onLoad}
        position={{ lat: parseFloat(data.lat), lng: parseFloat(data.lng) }}
        icon={customIcon(userTypePinPNG as unknown as string, sizeRef.current)}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      //onClick={ handleMarkerClick}
      >
        {!isMobile && (infoWindowOpen || isMarkerActive) && (
          <InfoWindowF
            position={{ lat: parseFloat(data.lat), lng: parseFloat(data.lng) }}
            options={{ disableAutoPan: true }}
            onCloseClick={handleWindowClose}>
            <MMMarkerInfoWindowDetails data={data} onClose={handleWindowClose} />
          </InfoWindowF>
        )}
      </MarkerF>
    );

  return null

}
export const StartChat = async (idsOrdered: number[], authStatus: string | null, navigate: (to: To, options?: NavigateOptions) => void, setChatFunc: (directChatUsers: DirectChatUsers) => Promise<any> | void, skipUsersInTestCheck: boolean = true
): Promise<void> => {
  if (authStatus !== 'authenticated') {
    navigate(`/Conversations`)
    return;
  }
  const setChatArg: DirectChatUsers = { id: idsOrdered[0], messageToId: idsOrdered[1], };
  // If setChatFunc returns a Promise, this will await it.
  const { conversationId } = await setChatFunc(setChatArg);
  // Only navigate AFTER chat is set up
  navigate(`/Conversations${conversationId ? `/?conversationId=${conversationId}` : ''}`)
};


export const MMMarkerInfoWindowDetails: React.FC<{ data: any, onClose?: () => void, children?: React.ReactNode, containerSx?: object }> = ({ data, onClose, children, containerSx }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { data: profile, isLoading, isFetching, isSuccess, isError, error, } = useGetProfileQuery(data.id)
  const [SetChat, { isLoading: isLoadingSetChat, isSuccess: isSuccessSetChat, isError: isErrorSetChat, data: setChatData, }] = useSetChatUserMutation()
  const { authStatus, profile: profileLoggedIn, isLoading: isLoadingpProfileLoggedIn } = useAuthProfile()

  // useEffect(() => {
  //   if (isSuccessSetChat) {
  //     console.log("setChatData about to navigate to /Messages", setChatData)
  //     navigate("/Messages", { state: { chatAndUserData: setChatData } })
  //   }

  // }, [isSuccessSetChat, setChatData, navigate])//dispatch, navigate,data.id, 

  if (isError) {
    const errMsg = 'status' in error ? `Error: ${error.status}` : 'error';
    return <div>{errMsg}</div>;
  }

  if (isErrorSetChat)
    return <Alert severity="error">Oops... Error occurred while initiating a chat.  Please try again later.</Alert>

  const addressTerm = data.formattedsearchterm || profile?.formattedsearchterm
  const showSearchTerm = !!(addressTerm?.trim().length)

  return (
    <Stack direction="column" sx={{ width: '280px', maxHeight: '360px', overflow: 'hidden', borderRadius: '12px', background: 'linear-gradient(145deg, rgba(244, 240, 255, 0.97) 0%, rgba(236, 232, 250, 0.95) 50%, rgba(244, 240, 255, 0.97) 100%)', border: '1px solid rgba(164, 142, 233, 0.22)', boxShadow: '0 8px 32px rgba(101, 110, 255, 0.12), 0 2px 8px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.6)', ...containerSx }}>
      {/* Colored header — name + close button */}
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between"
        sx={{ background: 'linear-gradient(135deg, rgba(139,92,246,0.85) 0%, rgba(165,120,255,0.80) 100%)', px: 1.5, py: 1, flexShrink: 0, borderRadius: '12px 12px 0 0', boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.3)' }}>
        <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '0.875rem', lineHeight: 1.3, flexGrow: 1, pr: 0.5 }}>
          {data.name_public}
        </Typography>
        {onClose && (
          <IconButton size="small" onClick={onClose}
            sx={{ p: 0.25, color: 'rgba(255,255,255,0.8)', flexShrink: 0, mt: '-2px', mr: '-4px',
              '&:hover': { color: 'white', bgcolor: 'rgba(255,255,255,0.15)' } }}>
            <CloseIcon sx={{ fontSize: '1rem' }} />
          </IconButton>
        )}
      </Stack>

      {/* Fixed: badge+address and CTAs — never scroll away */}
      <Stack direction="column" gap={0.75} sx={{ px: 1.5, pt: 1, pb: 0.5, flexShrink: 0 }}>
        <Stack direction="row" gap={1} alignItems="center" sx={{ overflow: 'hidden' }}>
          <PinChip category="User" type={data.type} size="small" iconSizePx={16} sx={{ pt: 0.5, pb: 0.5, height: '24px', fontSize: '0.7rem', flexShrink: 0 }} />
          {showSearchTerm && (
            <Stack direction="row" gap={0.5} alignItems="flex-start" sx={{ minWidth: 0, overflow: 'hidden' }}>
              <RoomOutlinedIcon sx={{ fontSize: '0.875rem', color: 'primary.main', flexShrink: 0, mt: '1px' }} />
              <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.3 }}>{addressTerm}</Typography>
            </Stack>
          )}
        </Stack>
        <Stack direction="row" gap={1}>
          <Button
            disabled={!isSuccess}
            id="pin_message_button"
            variant="contained"
            size="small"
            startIcon={<SmsOutlinedIcon />}
            disableElevation
            onClick={() => navigate({
              pathname: "/Conversations", search: new URLSearchParams({ directId: profile.id, directNamePublic: profile.name_public }).toString(),
            })}
            sx={{ color: 'white', flexGrow: 1, textTransform: 'none', fontSize: '0.75rem', background: 'linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)', '&:hover': { background: 'linear-gradient(135deg, #7C3AED 0%, #6D28D9 100%)' } }}
          >
            Chat
          </Button>
          <Button
            disabled={!isSuccess}
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<MenuBookIcon />}
            disableElevation
            onClick={() => { dispatch(setPublicPinClicked(data.id)); dispatch(setBottomSheetState(true)); dispatch(setActivePinModal(null)); }}
            sx={{ textTransform: 'none', fontSize: '0.75rem' }}
          >
            Learn more
          </Button>
        </Stack>
      </Stack>

      {/* Scrollable: story content only */}
      <Stack direction="column" gap={0.75} sx={{ px: 1.5, pb: 1, overflow: 'auto', flexGrow: 1 }}>
        {(isLoading || isFetching) ? (
          <Skeleton animation="wave" variant="rounded" width="100%" height={60} />
        ) : isSuccess ? (
          <>
            {profile.comment && (
              <Box sx={{ borderLeft: '3px solid #E0DEFF', pl: 1.5, py: 0.5, backgroundColor: '#FAFAFA', borderRadius: 1 }}>
                <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.6, whiteSpace: 'pre-line' }}>{profile.comment}</Typography>
              </Box>
            )}
            {data.web_site && <Typography variant="body2">Website:&nbsp;<Link target="_blank" rel="noopener noreferrer" href={data.web_site}>{data.web_site}</Link></Typography>}
            <div>{children}</div>
          </>
        ) : null}
      </Stack>
    </Stack>
  );
}


export const Warriors: React.FC = () => {
  const agentData = useAgentData();
  const userTypesState = useSelector((state: any) => state.filter.showWarriors, shallowEqual)
  const unknownIsGood = useSelector((state: any) => state.filter.unknownIsGood)
  const [userTypePinSVG, setUserTypePinSVG] = useState<string | null>(null);
  const { condition, baseName } = React.useContext<Condition>(coonditionContext);
  useEffect(() => {
    const fetchImage = async () => {
      // if (baseName) {
      //const path = await loadImage(`../../assets/patienticon${baseName}.png`);
      const path = await loadImage(`patienticon${baseName}.png`);
      setUserTypePinSVG(path)
      // }
    };
    fetchImage();
  }, [baseName]); // Re-run effect if baseName changes

  //const {data: warriors, isLoading, isSuccess, isError, error, } = useGetProfilesPinDataQuery();
  // const arg = (agentData && !agentData?.args?.show_objects)? skipToken : undefined
  const { data: warriorsData, isLoading, isSuccess, isError, error, } = useGetProfilesPinDataForDefaultPointQuery();

  const { authStatus, profile: loggedInUserProfile, isLoading: isLoadingLoggedInUserProfile, isSuccess: isSuccessLoggedInUserProfile, isError: isErrorLoggedInUserProfile, error: errorLoggedInUserProfile /*, userAttributesStateStatus*/ } = useAuthProfile()

  if (isLoading || isLoadingLoggedInUserProfile || authStatus === 'configuring')
    return (<CircularProgressCentered />)

  const loggedInUserId = (isSuccessLoggedInUserProfile && authStatus === 'authenticated') ? loggedInUserProfile.id : null

  // if (isError) {
  //   const errMsg = 'status' in error ? `Error: ${error.status}` : 'error';
  //   return <div>{errMsg}</div>;
  // }
  // if (isErrorLoggedInUserProfile) {
  //   const errMsg = 'status' in errorLoggedInUserProfile ? `Error: ${errorLoggedInUserProfile.status}` : 'error';
  //   return <div>{errMsg}</div>;
  // }
  const skipAllTypes = typeof userTypesState === 'boolean' ? !userTypesState : false
  if (skipAllTypes && (!agentData?.userPins || !agentData?.userPins?.length)) {
    return null
  }
  //user marker drawn separatly using <UserMarker>  
  const warriors = (agentData?.args?.show_objects && true) ? agentData?.userPins : warriorsData
  if ((isSuccess || agentData?.args?.show_objects) && isSuccessLoggedInUserProfile && userTypePinSVG)
    return (<>
      {warriors?.map(
        (row: any) => {
          const isLoggedInPing = loggedInUserId === row.id//refactor  const isLoggedInPing = iamId === row.iam_id
          //console.log(iamId, row.iam_id, iamId !== row.iam_id )
          return ((agentData || (ShowMarkerType(row.type, userTypesState, unknownIsGood) && !isLoggedInPing)) && <MMMarker data={row} key={row.id} />)
        })
      }
    </>
    )
  return null
}


export const MMMarker = React.memo(MMMarkerNotMemoized);

